module.exports = "<router-outlet></router-outlet>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/Pages/tasks/existingpatient/existingpatient.component.html
// module id = ./src/app/Pages/tasks/existingpatient/existingpatient.component.html
// module chunks = main